<main class="project-page">

  <section class="project-title" *ngIf="view() === 'title'">

    <div class="project-title__bar">
      <app-toolbar />
    </div>

    <h1>{{ project().title }}</h1>

    <a
      class="project-title__next"
      [routerLink]="['/projects', project().slug, 'gallery']">
      Next
    </a>

  </section>

  <section class="project-gallery" *ngIf="view() === 'gallery'">
    <div
      class="project-gallery__screen"
      *ngFor="let image of project().galleryImages; let i = index">

      <img [src]="image" alt="">
    </div>

    <div class="project-gallery__bar">
      <app-toolbar />
    </div>

    <div class="project-gallery__bottom">
      <a [routerLink]="['/projects', project().slug, 'about']">
        About
      </a>

      <div class="project-gallery__info">
        <span>{{ project().title }}</span>
        <p>{{ project().category }}</p>
      </div>

      <div class="project-gallery__progress">
        {{ galleryProgress }}%
      </div>

      <a [routerLink]="['/projects', nextProject().slug, 'title']">
        Next: Project next
      </a>
    </div>
  </section>

  <section class="project-about" *ngIf="view() === 'about'">
    <img class="project-about__bg" [src]="project().aboutBg" alt="">

    <div class="project-about__bar">
      <app-toolbar />
    </div>

    <div class="project-about-card">
      <a
        class="project-about-card__close"
        [routerLink]="['/projects', project().slug, 'gallery']">
        Close
      </a>

      <div class="project-about-card__content">
        <div class="project-about-card__text">
          <p *ngFor="let paragraph of project().aboutText">
            {{ paragraph }}
          </p>
        </div>

        <div class="project-about-card__meta">
          <div class="project-about-meta-row project-about-meta-row--top">
            <div>
              <span>Client:</span>
              <p>{{ project().client }}</p>
            </div>

            <div>
              <span>Site</span>
              <p>{{ project().site }}</p>
            </div>

            <div>
              <span>Year</span>
              <p>{{ project().year }}</p>
            </div>
          </div>

          <div class="project-about-meta-row project-about-meta-row--bottom">
            <div>
              <span>Role:</span>
              <p>
                <ng-container *ngFor="let role of project().roles">
                  {{ role }}<br>
                </ng-container>
              </p>
            </div>

            <div>
              <span>Credits:</span>
              <p>
                <ng-container *ngFor="let credit of project().credits">
                  {{ credit.role }}<br>
                </ng-container>
              </p>
            </div>

            <div>
              <span>&nbsp;</span>
              <p>
                <ng-container *ngFor="let credit of project().credits">
                  {{ credit.name }}<br>
                </ng-container>
              </p>
            </div>
          </div>
        </div>
      </div>

      <a
        class="project-about-card__next"
        [routerLink]="['/projects', nextProject().slug, 'title']">
        Next: Project next {{ nextProject().title }}
      </a>
    </div>
  </section>

</main>
